






















import { Component, Emit, Prop, Ref } from 'nuxt-property-decorator'
import { merge } from 'lodash'
import { ComponentVue } from '@/base'
import { defaultSystemCode, SystemCode, systemCodeApi } from '@/api'
import { AtomTextField } from '@/components/atoms'
import {
  defaultSystemCodeWithKey,
  SystemCodeWithKey
} from '@/api/models/system-code/SystemCodeWithKey'

@Component({
  components: {}
})
export default class InputCodeMultiple extends ComponentVue {
  @Prop({ type: String, required: true })
  codeKey!: string

  @Ref()
  textField!: AtomTextField

  @Prop({ type: String })
  label!: string

  @Prop({ type: String })
  placeholder!: string

  @Prop({ type: Array, default: () => [] })
  items!: SystemCode[]

  @Prop({
    type: Boolean,
    default: false
  })
  hideName!: boolean

  @Prop({ type: Boolean, default: false })
  clearable!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  hideDetails!: boolean

  @Prop({ type: Array })
  rules!: any

  @Prop({ type: String, default: '' })
  errorMessage!: string

  @Prop({
    type: Boolean,
    default: true
  })
  noResize!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  flat!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  outlined!: boolean

  @Prop({
    type: String
  })
  mask!: string

  @Prop({
    type: Boolean,
    default: false
  })
  autofocus!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabled!: boolean

  systemCode: SystemCodeWithKey = defaultSystemCodeWithKey()

  systemCodeFetched: boolean = false

  get value() {
    return this.items.map(item => item.code).join(',')
  }

  created() {
    this.fetchSystemCode()
  }

  activated() {
    this.fetchSystemCode()
  }

  deactivated() {
    this.systemCodeFetched = false
  }

  async fetchSystemCode() {
    if (!this.systemCodeFetched) {
      this.systemCodeFetched = true
      this.systemCode = await systemCodeApi.getSystemCodeWithKey(this.codeKey)
    }
  }

  onInput(value: string) {
    const items = value.split(',').map(code => {
      const item = this.systemCode.codes.find(item => {
        return item.code === code
      })

      return (
        item ??
        merge(defaultSystemCode(), {
          codeKey: this.codeKey,
          code
        })
      )
    })

    this.$emit('input:system-code', items)
  }

  onListClick(): void {
    this.$modalCode.open({
      codeKey: this.codeKey,
      title: this.systemCode.name,
      defaultCode: this.value ?? '',
      systemCodes: this.systemCode.codes,
      multiple: true,
      onOkClick: (items: SystemCode[]) => {
        this.debug('onListClick', items)
        if (items.length > 0) {
          const text = this.items.map(item => item.code).join(',')
          this.$emit('input', text)
          this.$emit('input:system-code', items)
          this.$emit('change', text)
          this.$emit('change:system-code', items)
        }
      }
    })
  }

  @Emit('keydown:enter')
  onKeydownEnter() {}
}
